// Helper API bersama untuk ChatbotAI.jsx dan OmnichannelInbox.jsx.

// Ganti sesuai alamat backend Anda (lihat folder backend/)
// export const API_BASE = "http://localhost:4000/api";
 export const API_BASE = "https://pixelku-api.merakisolusi.com/api";

// Diisi komponen utama: dipanggil saat server menolak token (401) pada request ber-token.
let unauthorizedHandler = null;
export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = handler;
}

export async function apiRequest(path, { method = "GET", token, body, isFormData = false, isRawBody = false, contentType } = {}) {
  const response = await fetch(API_BASE + path, {
    method,
    headers: {
      ...(isFormData || isRawBody ? {} : { "Content-Type": "application/json" }),
      ...(isRawBody && contentType ? { "Content-Type": contentType } : {}),
      ...(token ? { Authorization: "Bearer " + token } : {}),
    },
    body: isFormData || isRawBody ? body : body ? JSON.stringify(body) : undefined,
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (response.status === 401 && token && unauthorizedHandler) unauthorizedHandler();
    const error = new Error(data.error || "Terjadi kesalahan pada server.");
    error.status = response.status;
    throw error;
  }
  return data;
}
